export const ORDER_LIST_DEFAULT_PAGE_SIZE = 25;
